import React from 'react';
import {useAppSelector} from "../../../../../../common/hook";
import {getProfileData} from "../../../../../../entities/Profile/model/selectors/getProfileData/getProfileData";
import {
    ADDITIONAL_PHONE,
    ADDRESS,
    BIRTHDATE,
    COUNTRY,
    CURRENT_DATE_TIME,
    EMAIL,
    MOBILE_PHONE,
    PAYMENT_CURRENCY,
    REMINDERS,
    SOCIAL_MEDIA,
    TIME_ZONE
} from "entities/constants/constants";
import {ReactComponent as FacebookIcon} from '../../../../../../assets/main/profile-box/social-network/facebook.svg';
import {ReactComponent as InstagramIcon} from '../../../../../../assets/main/profile-box/social-network/instagram.svg';
import {ReactComponent as TelegramIcon} from '../../../../../../assets/main/profile-box/social-network/telegram.svg';
import {ReactComponent as ViberIcon} from '../../../../../../assets/main/profile-box/social-network/viber.svg';
import {ReactComponent as VKontakteIcon} from '../../../../../../assets/main/profile-box/social-network/vkontakte.svg';
import {ReactComponent as WhatsappIcon} from '../../../../../../assets/main/profile-box/social-network/whatsapp.svg';
import {Link} from "react-router-dom";


type SocialIcon = React.ComponentType<React.SVGProps<SVGSVGElement> & { title?: string | undefined }>;

const socialIcons: Record<string, SocialIcon> = {
    Facebook: FacebookIcon,
    Instagram: InstagramIcon,
    Telegram: TelegramIcon,
    Viber: ViberIcon,
    VKontakte: VKontakteIcon,
    Whatsapp: WhatsappIcon,
};

export const InfoStudents = () => {
    const data = useAppSelector(getProfileData)


    return (
        <>
            <div className="data-cards-box">
                <div className="data-card">
                    <div className="row">
                        <p className="row-title">{BIRTHDATE}</p>
                        <p>{data?.birthDate} г.</p>
                    </div>
                    <div className="row">
                        <p className="row-title">{EMAIL}</p>
                        <p>
                            <a href={`mailto:${data?.email}`}>
                                {data?.email}
                            </a>
                        </p>
                    </div>
                    <div className="row">
                        <p className="row-title">{MOBILE_PHONE}</p>
                        <p>
                            <a href={`tel:${data?.phone}`}>
                                {data?.phone}
                            </a>
                        </p>
                    </div>
                    <div className="row">
                        <p className="row-title">{ADDITIONAL_PHONE}</p>
                        <p>
                            <a href={`tel:${data?.additionalPhone}`}>
                                {data?.additionalPhone}
                            </a>
                        </p>
                    </div>
                </div>
                <div className="data-card">
                    <div className="row">
                        <p className="row-title">{TIME_ZONE}</p>
                        <p>{data?.timeZone}</p>
                    </div>
                    <div className="row">
                        <p className="row-title">{CURRENT_DATE_TIME}</p>
                        <p>{data?.date},{" "}{data?.time}</p>
                    </div>
                    <div className="row">
                        <p className="row-title">{COUNTRY}</p>
                        <p>{data?.country}</p>
                    </div>
                    <div className="row">
                        <p className="row-title">{ADDRESS}</p>
                        <p>{data?.address}</p>
                    </div>
                </div>
                <div className="data-card">
                    <div className="row">
                        <p className="row-title">{PAYMENT_CURRENCY}</p>
                        <p>{data?.currency}</p>
                    </div>
                    <div className="row">
                        <p className="row-title">{SOCIAL_MEDIA}</p>
                        <div className="social-links">
                            {data?.socials.map((social, index) => {
                                const SocialIcon = socialIcons[social.name];
                                return social.link ? (
                                    <p className="p-icon" key={index}>
                                        <a href={social.link} target="_blank" rel="noopener noreferrer">
                                            {social.name}
                                        </a>
                                        {SocialIcon && <SocialIcon className="icon"/>}
                                    </p>
                                ) : null;
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="info-card">
                <div className="info-card-hdr">
                    <div className="title-box">
                        <p className="info-card-title h6">{REMINDERS}</p>
                    </div>
                </div>
                <div className="info-card-content large-row-indent">
                    {data?.notifications.map((notification, index) => (
                        <div className="row" key={index}>
                            {notification.type === 'test' && (
                                <div className="inline-text-btn">
                                    <p>{notification.text}</p>
                                    <Link className='btn secondary small in-text'
                                          to={`/test/${notification.idTest}`}><span>Пройти сейчас</span></Link>
                                </div>
                            )}
                            {notification.type === 'restClasses' && (
                                <div className="row">
                                    <p>{notification.text}
                                        <span className="btn secondary small in-text">
                                            <span>
                                                <Link style={{boxShadow: 'none'}}
                                                  to={`/buy-course`}>{notification.count}</Link>
                                            </span>
                                        </span>
                                    </p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

